module.exports = {
  "country": "CS",
  "artist": "Željko Joksimović",
  "song": "Lane Moje",
  "year": "2004",
  "place": "2",
  "spotify": "0VFmXKjkFNZDs9LXA6Ja0g"
};